import React, { useEffect, useState } from "react";
import { getAttendanceDetails } from "_controllers/officer";
import { DateTime } from "luxon";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import exportExcel from "utils/excelGenerate";
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

const Attendance = () => {
  const { SAP_ID } = useParams();

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const fileName = `${SAP_ID}-attendence-report`;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dealers, setDealers] = useState([]);
  const [message, setMessage] = useState("");
  const [csvData, setCsvData] = useState([]);

  useEffect(async () => {
    // if (!planDate || !SAP_ID) return;

    // const today = DateTime.now();

    // const startDate =
    //   today.day > 27
    //     ? today.plus({ months: 1 }).startOf("month")
    //     : today.startOf("month");

    // const endDate = startDate.endOf("month");

    // setStartDate({
    //   year: startDate.year,
    //   month: startDate.month,
    //   day: startDate.day,
    // });
    // setEndDate({
    //   year: endDate.year,
    //   month: endDate.month,
    //   day: endDate.day,
    // });
    const startDate = moment().startOf("month").format("YYYY-MM-DD");

    const endDate = moment().endOf("month").format("YYYY-MM-DD");

    const plan = await getAttendanceDetails({
      SAP_ID,
      startDate,
      endDate,
    });
    console.log("ji", plan?.data);
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }, [message]);

  const timeSpent = (a, b) => {
    const test = moment.duration(moment(b ? b : "").diff(moment(a ? a : "")))
    return `${test.asMinutes().toFixed(0)} mins`
  };

  const { selectStartDate, selectEndDate } = Values

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log("lp", Values)
    const plan = await getAttendanceDetails({
      SAP_ID,
      startDate: selectStartDate,
      endDate: selectEndDate,
    });
    console.log("kop", plan?.data);
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(csvData.map(x => ({
      'SAP ID': x?.data?.SAP_ID,
      'Date': x._id.date,
      // 'Time Spent(mins)': x.total_count
    })), fileName)
  }

  return (
    <>
      <PageHeader title="Attendance" subtitle="Visit attendance report" />

      <SectionCard sx={{ mb: 3 }}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 2,
          }}
        >
          <TextField
            type="date"
            size="small"
            label="Start Date"
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 200 }}
            onChange={handleChange}
            value={selectStartDate}
            name="selectStartDate"
            variant="outlined"
          />
          <TextField
            type="date"
            size="small"
            label="End Date"
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 200 }}
            onChange={handleChange}
            value={selectEndDate}
            name="selectEndDate"
            variant="outlined"
          />
          <Box sx={{ display: "flex", gap: 1, ml: { sm: "auto" } }}>
            <Button
              type="submit"
              variant="contained"
              startIcon={<FilterAltOutlinedIcon />}
            >
              Apply
            </Button>
            <Button
              type="button"
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={generateExcel}
            >
              Download
            </Button>
          </Box>
        </Box>
      </SectionCard>

      {loading ? (
        <SectionCard disablePadding>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="center">Dealer's Visit</TableCell>
                  <TableCell align="left">Dealer Code</TableCell>
                  <TableCell align="left">Login Time</TableCell>
                  <TableCell align="left">Logout Time</TableCell>
                  <TableCell align="center">Time Spent</TableCell>
                </TableRow>
              </TableHead>
              {data?.length > 0 && (
                <TableBody>
                  {data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?._id?.date}</TableCell>
                      <TableCell align="center">{d?.data.length}</TableCell>
                      <TableCell align="left">
                        {d?.data.length > 0
                          ? d?.data.map((dealer, i) => (
                            <Tooltip
                              key={i}
                              title={dealer?.dealer?.name || ""}
                            >
                              <Box
                                component="span"
                                sx={{ cursor: "pointer" }}
                              >
                                {dealer?.dealerCode},
                              </Box>
                            </Tooltip>
                          ))
                          : "No Visit Today"}
                      </TableCell>
                      <TableCell sx={{ cursor: "pointer" }}>
                        {d?.data.length > 0
                          ?
                          d?.data[0].startTime ? moment(d?.data[0].startTime).subtract(330, 'minutes').format("hh:mm A") : "-"
                          : null}
                      </TableCell>
                      <TableCell sx={{ cursor: "pointer" }}>
                        {d?.data.length > 0
                          ?
                          d?.data[d.data.length - 1].endTime ? moment(d?.data[d.data.length - 1].endTime).subtract(330, 'minutes').format("hh:mm A") : "-"
                          : null}
                      </TableCell>
                      <TableCell align="center" sx={{ cursor: "pointer" }}>
                        {d?.data.length > 0
                          ? (timeSpent(
                            d?.data[0].startTime,
                            d?.data[d.data.length - 1].endTime
                          ))
                          : null}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          {(!data || data?.length === 0) && (
            <EmptyState
              icon={EventBusyOutlinedIcon}
              title="No attendance found"
              description="No visit attendance available for the selected period."
            />
          )}
        </SectionCard>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default Attendance;
